import { FilterValues, IFilterField, IFilterSection } from "@models/IFilterConfig";
import { ChipLabelFormatter, getChipLabel, getFieldSectionMap, isFieldActive } from "./filterBarUtils";
import { OptionLabels } from "./useFilterBar";

type Props = {
    sections: IFilterSection[];
    fields: IFilterField[];
    applied: FilterValues;
    optionLabels: OptionLabels;
    translate: ChipLabelFormatter;
    onRemove: (field: IFilterField) => void;
    onClearAll: () => void;
};

/**
 * Active filter chip strip. Renders nothing when no filter is active.
 */
export const FilterChips = (props: Props) => {
    const { fields, applied, translate } = props;
    const sectionMap = getFieldSectionMap(props.sections);
    const active = fields.filter((field) => isFieldActive(field, applied[field.key]));

    if (!active.length) {
        return null;
    }

    return (
        <div className={"FilterBar-chips d-flex align-items-center flex-wrap gap-2"}>
            {active.map((field) => {
                const isExclusion = !!sectionMap[field.key]?.isExclusion;
                const valueLabel = getChipLabel(field, applied[field.key], translate, props.optionLabels[field.key]);

                return (
                    <span key={field.key} className={"FilterBar-chip" + (isExclusion ? " exclusion" : "")}>
                        <span className={"FilterBar-chip-label"}>{translate(field.label)}</span>
                        {valueLabel ? <span className={"FilterBar-chip-value"}>{valueLabel}</span> : null}
                        <button
                            type={"button"}
                            className={"FilterBar-chip-remove"}
                            aria-label={translate("remove")}
                            title={translate("remove")}
                            onClick={() => props.onRemove(field)}>
                            <i className={"fas fa-times"} />
                        </button>
                    </span>
                );
            })}
            <button type={"button"} className={"btn btn-link btn-sm p-0 FilterBar-clear-all"} onClick={props.onClearAll}>
                {translate("clear_all")}
            </button>
        </div>
    );
};
